import { combineReducers } from 'redux';
import { delay } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import prepareBody from '../utils/prepareBody';
import takeLatestFilter from '../utils/takeLatestFilter';
import managedValidator from '../utils/managedValidator';
import { GET_RACE_SUCCESS } from './race';
import { selectPlanId, selectRunnerId } from './auth';
import { getWorkoutDay } from './workouts';
import { CONFIRM_PLAN_PURCHASE_SUCCESS } from './signup';

export const SAVE_PROFILE = 'profile/SAVE_PROFILE';
export const SAVE_PROFILE_SUCCESS = 'profile/SAVE_PROFILE_SUCCESS';
export const SAVE_PROFILE_FAILURE = 'profile/SAVE_PROFILE_FAILURE';
export const CHANGE_FIELD = 'profile/CHANGE_FIELD';
export const TOGGLE_MODAL = 'profile/TOGGLE_MODAL';
export const CLOSE_MODAL = 'profile/CLOSE_MODAL';
export const OPEN_MODAL = 'profile/OPEN_MODAL';
export const OPEN_CONTACT_US_MODAL = 'profile/OPEN_CONTACT_US_MODAL';
export const CLOSE_CONTACT_US_MODAL = 'profile/CLOSE_CONTACT_US_MODAL';
export const CONTACT_US = 'profile/CONTACT_US';
export const CONTACT_US_SUCCESS = 'profile/CONTACT_US_SUCCESS';
export const CONTACT_US_FAILURE = 'profile/CONTACT_US_FAILURE';
export const OPEN_STRAVA_MODAL = 'profile/OPEN_STRAVA_MODAL';
export const CLOSE_STRAVA_MODAL = 'profile/CLOSE_STRAVA_MODAL';
export const PASS_CHANGE_START = 'profile/PASS_CHANGE_START';
export const PASS_CHANGE_SUCCESS = 'profile/PASS_CHANGE_SUCCESS';
export const PASS_CHANGE_FAILURE = 'profile/PASS_CHANGE_FAILURE';
export const UPLOAD_AVATAR = 'profile/UPLOAD_AVATAR';
export const UPLOAD_AVATAR_SUCCESS = 'profile/UPLOAD_AVATAR_SUCCESS';
export const UPLOAD_AVATAR_FAILURE = 'profile/UPLOAD_AVATAR_FAILURE';
export const SET_UPLOAD_AVATAR_IMAGE = 'profile/SET_UPLOAD_AVATAR_IMAGE';
export const UPGRADE_DATA = 'profile/UPGRADE_DATA';
export const UPGRADE_DATA_SUCCESS = 'profile/UPGRADE_DATA_SUCCESS';
export const UPGRADE_DATA_FAILURE = 'profile/UPGRADE_DATA_FAILURE';
export const SET_ERROR = 'profile/SET_ERROR';
export const PURCHASE_ECOACH_SUCCESS = 'profile/PURCHASE_ECOACH_SUCCESS';

// runner_name → First Last
// height → units (inches)
// weight → units (lbs)
// zipcode → 5-digit zip code
// units → {Metric, English}
// email → this adjusts a runner’s username as well

const readFromRace = (result) => {
    const name = result.Runner_name.split(' ');

    return {
        firstName: name[0],
        lastName: name[1],
        height: result.Height,
        weight: result.Weight,
        zipcode: result.Zipcode,
        email: result.Email,
        units: result.units,
        emailsetting: result.emailsetting,
        public: result.public,
        marketing: result.marketing,
        avatar: result.ProfilePic ? result.ProfilePic.replace(/"/g, '') : null,
        timezone: result.timezone ? result.timezone : 'US/Eastern',
        accountLevel: result.account_level,
        GPSwatch: result.GPSwatch,
        GPSwatchtype: result.GPSwatchtype,
    };
};

export function formReducer(state = {}, action) {
    switch (action.type) {
        case GET_RACE_SUCCESS:
            return {
                ...state,
                ...readFromRace(action.result),
            };
        case CHANGE_FIELD:
            return {
                ...state,
                [action.key]: action.val,
            };
        case UPLOAD_AVATAR_SUCCESS:
            return {
                ...state,
                avatar: action.result.profilepicURL1,
            };
        case PASS_CHANGE_SUCCESS:
            return {
                ...state,
                newPassword: null,
            };
        default:
            return state;
    }
}

export function valuesReducer(state = null, action) {
    switch (action.type) {
        case GET_RACE_SUCCESS:
            return {
                ...state,
                ...readFromRace(action.result),
            };
        case SAVE_PROFILE_SUCCESS:
            return {
                ...state,
                ...action.body,
            };
        default:
            return state;
    }
}

export function loading(state = false, action) {
    switch (action.type) {
        case SAVE_PROFILE:
            return true;
        case SAVE_PROFILE_SUCCESS:
        case SAVE_PROFILE_FAILURE:
            return false;
        default:
            return state;
    }
}

export function uploadAvatarLoading(state = false, action) {
    switch (action.type) {
        case UPLOAD_AVATAR:
            return true;
        case UPLOAD_AVATAR_SUCCESS:
        case UPLOAD_AVATAR_FAILURE:
            return false;
        default:
            return state;
    }
}

export function uploadAvatarError(state = null, action) {
    switch (action.type) {
        case UPLOAD_AVATAR:
        case UPLOAD_AVATAR_SUCCESS:
            return null;
        case UPLOAD_AVATAR_FAILURE:
            return action.error;
        default:
            return state;
    }
}

export function uploadAvatarImage(state = null, action) {
    switch (action.type) {
        case UPLOAD_AVATAR:
        case UPLOAD_AVATAR_SUCCESS:
            return null;
        case SET_UPLOAD_AVATAR_IMAGE:
            return action.image;
        default:
            return state;
    }
}

export function errors(state = {}, action) {
    switch (action.type) {
        case CHANGE_FIELD: {
            return {
                ...state,
                [action.key]: null,
            };
        }
        case SET_ERROR:
            return {
                ...state,
                [action.key]: action.error,
            };
        case CLOSE_MODAL:
            return {};
        default:
            return state;
    }
}

export function open(state = false, action) {
    switch (action.type) {
        case OPEN_MODAL:
            return true;
        case CLOSE_MODAL:
            return false;
        default:
            return state;
    }
}

export function contactUsModal(state = false, action) {
    switch (action.type) {
        case OPEN_CONTACT_US_MODAL:
            return true;
        case CLOSE_CONTACT_US_MODAL:
            return false;
        default:
            return state;
    }
}

export function passChangedResp(state = { success: null, msg: '' }, action) {
    switch (action.type) {
        case PASS_CHANGE_SUCCESS:
            return {
                ...state,
                success: true,
            };
        case PASS_CHANGE_FAILURE:
            return {
                ...state,
                success: false,
                msg: action.result.error_exp,
            };
        case CLOSE_MODAL:
            return {
                ...state,
                success: null,
                msg: '',
            };
        default:
            return state;
    }
}

export const upgradeData = (state = { Banner_image: '/img/e-upgrade.jpg' }, action) => {
    switch (action.type) {
        case UPGRADE_DATA_SUCCESS:
            return {
                ...state,
                ...action.result,
            };
        default:
            return state;
    }
};

export function upgradeLoading(state = false, action) {
    switch (action.type) {
        case UPGRADE_DATA:
            return true;
        case UPGRADE_DATA_SUCCESS:
        case UPGRADE_DATA_FAILURE:
            return false;
        default:
            return state;
    }
}

export function coachUpgradedSuccess(state = false, action) {
    switch (action.type) {
        case CONFIRM_PLAN_PURCHASE_SUCCESS:
            return action.result.ecoachUpgrade;
        default:
            return state;
    }
}

export default combineReducers({
    form: formReducer,
    values: valuesReducer,
    loading,
    errors,
    open,
    passChangedResp,
    uploadAvatarLoading,
    uploadAvatarError,
    uploadAvatarImage,
    upgradeData,
    upgradeLoading,
    contactUsModal,
    coachUpgradedSuccess,
});

export function* setErrorListener({ val, key }) {
    const fieldError = managedValidator(val, key);
    if (fieldError) {
        yield call(delay, 1000);
        yield put(setError({ key, error: fieldError }));
    }
}

export function* watchChange() {
    yield takeLatestFilter(CHANGE_FIELD, ({ key }) => key, setErrorListener);
}

export function* rootSaga() {
    yield watchChange();
}

export const changeField = (key, val) => ({
    type: CHANGE_FIELD,
    key,
    val,
});

export function setError({ key, error }) {
    return {
        type: SET_ERROR,
        key,
        error,
    };
}

export const openModal = () => ({
    type: OPEN_MODAL,
});

export const closeModal = () => ({
    type: CLOSE_MODAL,
});

export const openContactUsModal = () => ({
    type: OPEN_CONTACT_US_MODAL,
});

export const closeContactUsModal = () => ({
    type: CLOSE_CONTACT_US_MODAL,
});

export const openStravaModal = () => ({
    type: OPEN_STRAVA_MODAL,
});

export const closeStravaModal = () => ({
    type: CLOSE_STRAVA_MODAL,
});

export const triggerEcoachSuccess = () => ({
    type: PURCHASE_ECOACH_SUCCESS,
});

export const changePassword = newPass => ({
    types: [PASS_CHANGE_START, PASS_CHANGE_SUCCESS, PASS_CHANGE_FAILURE],
    promise: ({ getState }) => fetch(`${process.env.RTAPI_URL}/API_blue.php`, {
        method: 'POST',
        body: prepareBody({
            plan_id: selectPlanId(getState()),
            runner_id: selectRunnerId(getState()),
            blue: newPass,
        }),
    }).then(res => res.json()),
});

export const saveProfileAction = body => ({
    types: [SAVE_PROFILE, SAVE_PROFILE_SUCCESS, SAVE_PROFILE_FAILURE],
    promise: ({ getState }) => fetch(`${process.env.RTAPI_URL}/API_manage_account.php`, {
        method: 'POST',
        body: prepareBody({
            plan_id: selectPlanId(getState()),
            runner_id: selectRunnerId(getState()),
            runner_name: `${body.firstName} ${body.lastName}`,
            height: body.height,
            weight: body.weight,
            zipcode: body.zipcode,
            email: body.email,
            units: body.units,
            public: body.public,
            marketing: body.marketing,
            emailsetting: body.emailsetting,
            timezone: body.timezone,
            GPSwatch: body.GPSwatch,
            GPSwatchtype: body.GPSwatchtype,
        }),
    }).then(res => res.json()),
    body,
});

export const setUploadAvatarImage = image => ({
    type: SET_UPLOAD_AVATAR_IMAGE,
    image,
});

let uploadCount = 0;

export const uploadAvatar = file => ({
    types: [UPLOAD_AVATAR, UPLOAD_AVATAR_SUCCESS, UPLOAD_AVATAR_FAILURE],
    promise: ({ getState }) => fetch(`${process.env.RTAPI_URL}/API_profilepic.php`, {
        method: 'POST',
        body: prepareBody({
            plan_id: selectPlanId(getState()),
            runner_id: selectRunnerId(getState()),
            img_file: file,
        }),
    }).then(res => res.json())
    .then((result) => {
        if (result.success === 'false') {
            const error = result.errormsg || 'Something went wrong, please try again.';
            throw new Error(error);
        }
        uploadCount += 1;
        return {
            ...result,
            profilepicURL: `${result.profilepicURL}?new=${uploadCount}`,
            profilepicURL1: `${result.profilepicURL1}?new=${uploadCount}`,
        };
    }),
});

export const getUpgradeDataAction = () => ({
    types: [UPGRADE_DATA, UPGRADE_DATA_SUCCESS, UPGRADE_DATA_FAILURE],
    promise: ({ getState }) => {
        const state = getState();
        const race = state.race.info;
        const totalWorkouts = race.plan_week * 7;
        const raceDate = race.race_date;
        return fetch(`${process.env.RTAPI_URL}/API_upgrade.php`, {
            method: 'POST',
            body: prepareBody({
                plan_id: selectPlanId(state),
                runner_id: selectRunnerId(getState()),
                training_day: getWorkoutDay({ totalWorkouts, raceDate }),
            }),
        }).then(res => res.json());
    },
});

export const contactUs = body => ({
    types: [CONTACT_US, CONTACT_US_SUCCESS, CONTACT_US_FAILURE],
    promise: ({ getState }) => {
        const state = getState();
        const { email } = state.profile.values;
        return fetch(`${process.env.RTAPI_URL}/API_contact1.php`, {
            method: 'POST',
            body: prepareBody({
                ...body,
                plan_id: selectPlanId(state),
                runner_id: selectRunnerId(getState()),
                email,
            }),
        }).then(res => res.json());
    },
});



/** WEBPACK FOOTER **
 ** ./src/redux/profile.js
 **/